import { render } from "./VideoList.vue?vue&type=template&id=585efd68&scoped=true&bindings={\"maxVideo\":\"props\",\"scrollTop\":\"data\",\"windowHeight\":\"data\",\"videos\":\"options\",\"trans\":\"options\",\"handleScroll\":\"options\",\"scrollToTop\":\"options\",\"store\":\"setup\"}"
import script from "./VideoList.vue?vue&type=script&lang=js"
export * from "./VideoList.vue?vue&type=script&lang=js"

import "./VideoList.vue?vue&type=style&index=0&id=585efd68&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-585efd68"

export default script